module.exports = __webpack_public_path__ + "static/media/compensation-bonus-bg.a13c15d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/compensation-bonus-bg.png
// module id = 1851
// module chunks = 103